import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Table,
  Modal,
  Dropdown,
} from "react-bootstrap";
import UserBuybaner from "./UserBuybaner";
import FooterContentSection from "./FooterContentSection";
import Header from "./header";
import ExportApi from "../api/ExportApi";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "react-lazy-load-image-component/src/effects/blur.css";
import OutsideClickHandler from "react-outside-click-handler";
import Login from "./Login";
// import UserAskBidList from "./UserAskBidList";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import _ from "lodash";
import Footer from "./footer";
import {useAuthUser} from "../customHooks/useAuthUser";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";
import SortSvg from "../assets/svg/SortSvg";

const UserBuySell = ({seoData}) => {
  const loggedInUser = useAuthUser();
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const htmlString =
    "<p class='tl_name'><strong>Why batch</strong><p class='inn-text'>If you only want to buy one item but would like to<br/> bid on multiple items to get the best deal this tool<br/> is for you!<p/><br/><strong>How it works</strong><p class='inn-text'>When any item in the batch sells to you, all of <br/> your existing bids on the other items in the batch<br/> will be automatically deactivated. This makes it<br/> safe for you to bid on many items without risking<br/> to purchase more than one item.</p><br/><strong>Instructions</strong><br/><p class='inn-text'><strong>Create Batch</strong><br/>1. Select the items you would like to Batch.<br/>2. Click batch (All selected items will be Batched).<br/><br/><strong>Remove items</strong><br/>1. Select items you would like to remove.<br/>2. Click unbatch (All selected items will be removed from Batch).<br/><br/><strong>Add Batch</strong><br/>1. Select items you would like to add.<br/>2. Click batch (All selected items will be added to Batch).</p>";
  const [productData, setproductData] = useState([]);
  const [descriptionindex, setdescriptionindex] = useState();
  const [ask, setAsk] = useState();
  const [showModal, setShowModal] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(false);
  const [Bid, setBid] = useState();
  const [AskBid, setAskBid] = useState();
  const [currentSortOrder, setCurrentSortOrder] = useState(1);
  const [currentSortKey, setCurrentSortKey] = useState(null);
  const [FilterList, setFilterList] = useState();
  const [condition1, setcondition1] = useState([]);
  const [brandShow, setBrandShow] = useState(false);
  const [chipsetShow, setChipsetShow] = useState(false);
  const [seriesShow, setSeriesShow] = useState(false);
  const [chipset, setchipset] = useState([]);
  const [brand, setbrand] = useState([]);
  const [modelShow, setModelShow] = useState(false);
  const [bidStatus, setBidStatus] = useState(false);
  const [askStatus, setAskStatus] = useState(false);
  const [loading, setLoading] = useState(0);
  const [showFilterModel, setShowFilterModel] = useState(false);
  const [conditionKey, setconditionKey] = useState([]);
  const [chipsetKey, setchipsetKey] = useState([]);
  const [brandKey, setbrandKey] = useState([]);
  const [seriesKey, setseriesKey] = useState([]);
  const [modalKey, setModalKey] = useState([]);
  const [condition, setcondition] = useState([]);
  const [series, setseries] = useState([]);
  const [model, setmodel] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [hideBatchStatus, setHideBatchStatus] = useState(false);
  const [batchCount, setBatchCount] = useState(0);
  const [batchData, setBatchData] = useState([]);
  const [batchStatus, setBatchStatus] = useState();
  const [askLoading, setAskLoading] = useState(0);
  const [showButtonLoader, setShowButtonLoader] = useState(false);
  const [showUnbatchLoader , setShowUnbatchLoader]= useState(false)

  const [alreadyCreatedBatch, setAlreadyCreatedBatch] = useState(false);
  const [descriptionindex1, setdescriptionindex1] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [openPlaceBidDropdown, setOpenPlaceBidDropdown] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [mainloader, setMainloader] = useState(false);
  const [modelShowMore, setModelShowMore] = useState(false);
  const [total, setTotal] = useState();
  const [pageOffset, setPageOffset] = useState(0);
  const [askliston, setAskliston] = useState(false);
  const [loader, setLoader] = useState(false);
  // const [allproducts, setAllProducts] = useState();
  const [uncheckedbox, setUncheckedBox] = useState(true);
  const [searchString, setSearchString] = useState("");
  const [showbatch, setShowBatch] = useState(false);
  const [showaskbatch, setShowAskBatch] = useState(false);
  const [sortColumn, setSortColumn] = useState(""); // Column to sort by
  const [sortOrder, setSortOrder] = useState("");
  const [finalProductList , setFinalProductList] = useState([])
  const [askCount, setAskCount] = useState(0);
  const [bidCount, setBidCount] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const dataTableScrollRef = useRef(null);

  const itemsPerPage = 10;

  const navigate = useNavigate();

  const [showMore, setShowMore] = useState({
    showMore: false,
    showLess: false,
  });
 
  useEffect(() => {
    const chip =
      chipset?.length +
      condition1?.length +
      brand?.length +
      series?.length +
      model?.length;
    setTotal(chip);
    setFilterCount(chip);

    if (chip > 4 && !showMore.showLess) {
      setShowMore((prev) => ({
        ...prev,
        showMore: true,
      }));
    } else if (chip > 4 && showMore.showLess) {
      setShowMore((prev) => ({
        ...prev,
        showMore: false,
      }));
    } else {
      setShowMore((prev) => ({
        ...prev,
        showMore: false,
        showLess: false,
      }));
    }
  }, [chipset, condition1, brand, series, model]);

  const debounceSearch = useCallback(
    _.debounce((search) => {
      setMainloader(true);
      const data = {
        condition: [],
        chipset: [],
        brand: [],
        series: [],
        model: [],
        currentPage: 1,
        searchString: search,
        sortColumn,
        sortOrder: sortOrder,        
        batch: hideBatchStatus,
        id:loggedInUser?.id
      };

      ExportApi.buysellfilter(data)
        .then((resp) => {
          setMainloader(false);

          let products = resp?.data?.Data;
          const totalpages = resp?.data?.Total;
          setTotalPages(totalpages);

          if (hideBatchStatus == true){
          let BatchStatus =  products

          if (hideBatchStatus == true) {
            let BCount = products.length / 2;
            setBatchCount(BCount === 0.5 ? BCount : Math.ceil(BCount) - 1);
            setBatchData(BatchStatus);
          } else {
            setBatchData([]);
          }
        }
          setproductData(products);
        })
        .catch((err) => {
          setMainloader(false);
        });
    }, 1000),
    []
  );

  const handleSearch = (e) => {
    const search = e.trim();

    debounceSearch(search);
  };

  //for the Table Sort that takes a sorting key (key) as a parameter
  const sortHereLowestAsk = (key, data) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;

    // return
    if (data == "ask") {
      // Filter out ALL items without lowest_ask (null, undefined, 0, or falsy)
      const zeroLowestAskData = productData.filter(
        (item) => item.lowest_ask == null || item.lowest_ask === 0 || item.lowest_ask === ""
      );
      const filteredData = productData.filter(
        (item) => item.lowest_ask != null && item.lowest_ask !== 0 && item.lowest_ask !== ""
      );

      const sortedData = [...filteredData].sort((a, b) => {
        let aValue, bValue;

        if (a["type"] == 1) {
          // Sort by new_retail_website_price
          aValue = a.new_retail_website_price != null && a.new_retail_website_price !== "" ? Number(a.new_retail_website_price) : null;
        } else {
          // Sort by lowest_ask - convert to number for proper numeric comparison
          aValue = a.lowest_ask != null && a.lowest_ask !== "" ? Number(a.lowest_ask) : null;
        }

        if (b["type"] == 1) {
          // Sort by new_retail_website_price
          bValue = b.new_retail_website_price != null && b.new_retail_website_price !== "" ? Number(b.new_retail_website_price) : null;
        } else {
          // Sort by lowest_ask - convert to number for proper numeric comparison
          bValue = b.lowest_ask != null && b.lowest_ask !== "" ? Number(b.lowest_ask) : null;
        }

        // Handle null values (shouldn't happen due to filter, but safety check)
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return 1;
        if (bValue == null) return -1;

        if (aValue < bValue) return -1 * sortOrder;
        if (aValue > bValue) return sortOrder;
        return 0;
      });

      const finalSortedData = [...sortedData, ...zeroLowestAskData];

      setCurrentSortKey(key);
      setCurrentSortOrder(sortOrder);

      setproductData(finalSortedData);
    } else {
      // Filter out ALL items without highest_bid (null, undefined, 0, or falsy)
      const zeroHighestBidData = productData.filter(
        (item) => item.highest_bid == null || item.highest_bid === 0 || item.highest_bid === ""
      );
      const filteredData = productData.filter(
        (item) => item.highest_bid != null && item.highest_bid !== 0 && item.highest_bid !== ""
      );

      const sortedData = [...filteredData].sort((a, b) => {
        let aValue, bValue;

        if (a["type"] == 1) {
          // Sort by new_retail_website_price
          aValue = a.new_retail_website_price != null && a.new_retail_website_price !== "" ? Number(a.new_retail_website_price) : null;
        } else {
          // Sort by highest_bid - convert to number for proper numeric comparison
          aValue = a.highest_bid != null && a.highest_bid !== "" ? Number(a.highest_bid) : null;
        }

        if (b["type"] == 1) {
          bValue = b.new_retail_website_price != null && b.new_retail_website_price !== "" ? Number(b.new_retail_website_price) : null;
        } else {
          bValue = b.highest_bid != null && b.highest_bid !== "" ? Number(b.highest_bid) : null;
        }
        
        // Handle null values (shouldn't happen due to filter, but safety check)
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return 1;
        if (bValue == null) return -1;
        
        if (aValue < bValue) return -1 * sortOrder;
        if (aValue > bValue) return sortOrder;
        return 0;
      });

      const finalSortedData = [...sortedData, ...zeroHighestBidData];

      setCurrentSortKey(key);
      setCurrentSortOrder(sortOrder);

      setproductData(finalSortedData);
    }
  };

  //key used for the get the name of the variable for sorting
  // Sorting functions for Order Id.
  //key used for the order id filter
  const sortHere = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = productData.sort((a, b) => {
      if (a[key] < b[key]) return -1 * sortOrder;
      if (a[key] > b[key]) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  const handleViewAsk = () => {
    setShowBatch(!showbatch);
    setSelectCheckBox(false);

    if (loggedInUser) {
      const newAskStatus = !askStatus;
      setAskStatus(newAskStatus);
      setBidStatus(false);

      if (newAskStatus) {
        HandleGetAskList(loggedInUser?.id);
      } else {
        HandleGetProductData(0, bidStatus, newAskStatus);
      }
    } else {
      setShowModal(true);
    }
  };

  
  const HandleGetProductData = (currentPage = null, bidStatus=false, askStatus=false) => {
    if (bidStatus) {
      HandleGetBidList(loggedInUser?.id)
    }
    else if (askStatus) {
      HandleGetAskList(loggedInUser?.id)
    }
    else {
      setMainloader(true);
      const data = {
        condition: condition1 || [],
        chipset: chipset || [],
        brand: brand || [],
      series: series || [],
      model: model || [],
      currentPage: currentPage ? currentPage : pageNumber + 1,
      searchString: searchString,
      sortColumn,
      sortOrder: sortOrder,
      batch: hideBatchStatus,
      id: loggedInUser?.id
    };


    ExportApi.buysellfilter(data)
      .then((resp) => {
        setMainloader(false);
        const totalpages = resp?.data?.Total;
        if (resp?.data?.Data?.length > 0) {
          let data = resp.data.Data;
          const onlyBatchItems = data.filter(item => item.isBatch == true);
          const nonBatchItems = data.filter(item => !item.isBatch || item.isBatch == false);
          setTotalPages(totalpages);
          setBatchData(onlyBatchItems)
          // setproductData(data);
          const finalProducts = hideBatchStatus
            ? [...onlyBatchItems, ...nonBatchItems]
            : data;
          setproductData(finalProducts);

        } else {
          setproductData([]);
        }
      })
      .catch((err) => {
        setMainloader(false);
      });
    }

  };


  //for getting the bid of product
  // here bidStatus is geted from the useState to make it work like switch,to make working it oppositelty.
   const handleViewBid = () => {
    setShowBatch(!showbatch);
    setSelectCheckBox(false);
    if (loggedInUser) {
      let status = !bidStatus;
      setBidStatus(status);
      setAskStatus(false);
      if (status) {
        HandleGetBidList(loggedInUser?.id);
      } else {
        HandleGetProductData(0 , status, askStatus);
      }
    } else {
      setShowModal(true);
    }
  };

  // Function to fetch only the ask count without loading full data
  // Calculate count on page load - matches the filtering logic in HandleGetAskList
  const HandleGetAskCount = (id) => {
    if (!id) return;
    ExportApi.askList(id)
      .then((resp) => {
        let count = 0;
        if (resp.data?.data && Array.isArray(resp.data.data)) {
          // Use the exact same filtering logic as HandleGetAskList
          for (let index = 0; index < resp.data.data.length; index++) {
            const element = resp.data.data[index];
            // Only count items with active asks (askAmount > 0 and productId exists)
            if (element.askAmount && element.askAmount > 0 && element.productId) {
              count++;
            }
          }
        }
        setAskCount(count);
      })
      .catch((err) => {
        console.error("Error fetching ask count:", err);
        setAskCount(0);
      });
  };

  const HandleGetAskList = (id) => {
    let Data = [];
    ExportApi.askList(id)
      .then((resp) => {
        for (let index = 0; index < resp.data?.data?.length; index++) {
          let obj = {};
          const element = resp.data.data[index];
          // Only include items with active asks (askAmount > 0 and productId exists)
          if (element.askAmount && element.askAmount > 0 && element.productId) {
            obj = { ...element, ...element.productId };
            Data.push(obj);
          }
        }
        // Update count with filtered data length
        setAskCount(Data.length);

        // If no asks found, set empty array
        if (Data.length === 0) {
          setproductData([]);
          setBatchData([]);
          setTotalPages(0);
          return;
        }

        if (hideBatchStatus) {
          const onlyBatchItems = Data.filter(item => item.batchStatus == true);
          const nonBatchItems = Data.filter(item => !item.batchStatus || item.batchStatus == false);

          setBatchData(onlyBatchItems)
          const finalProducts = hideBatchStatus
            ? [...onlyBatchItems, ...nonBatchItems]
            : Data;
          setproductData(finalProducts);
          setTotalPages(0);
        } else {
          setTotalPages(0);
          setproductData(Data);
          setBatchData([]);
        }

      })
      .catch((err) => {
        toast.error(err);
        setAskCount(0);
        setproductData([]);
      });
  };

  // Function to fetch only the bid count without loading full data
  // Calculate count on page load - matches the filtering logic in HandleGetBidList
  const HandleGetBidCount = (id) => {
    if (!id) return;
    ExportApi.getBidList(id)
      .then((resp) => {
        let count = 0;
        if (resp.data?.data && Array.isArray(resp.data.data)) {
          // Use the exact same filtering logic as HandleGetBidList
          for (let index = 0; index < resp.data.data.length; index++) {
            const element = resp.data.data[index];
            // Only count items with active bids (bidAmount > 0 and productId exists)
            if (element.bidAmount && element.bidAmount > 0 && element.productId) {
              count++;
            }
          }
        }
        setBidCount(count);
      })
      .catch((err) => {
        console.error("Error fetching bid count:", err);
        setBidCount(0);
      });
  };

  const HandleGetBidList = (id) => {
    let Data = [];
    ExportApi.getBidList(id)
      .then((resp) => {
        for (let index = 0; index < resp.data?.data?.length; index++) {
          let obj = {};
          const element = resp.data.data[index];
          // Only include items with active bids (bidAmount > 0 and productId exists)
          if (element.bidAmount && element.bidAmount > 0 && element.productId) {
            obj = { ...element, ...element.productId };
            Data.push(obj);
          }
        }
        // Update count with filtered data length
        setBidCount(Data.length);

        // If no bids found, set empty array
        if (Data.length === 0) {
          setproductData([]);
          setBatchData([]);
          setTotalPages(0);
          setLoading(1);
          return;
        }

        if (hideBatchStatus == true) {
          const onlyBatchItems = Data.filter(item => item.batchStatus == true);
          const nonBatchItems = Data.filter(item => !item.batchStatus || item.batchStatus == false);

          setBatchData(onlyBatchItems)
          const finalProducts = hideBatchStatus
            ? [...onlyBatchItems, ...nonBatchItems]
            : Data;
          setproductData(finalProducts);
          setTotalPages(0);
        }
        else {
          setTotalPages(0);
          setproductData(Data);
          setBatchData([]);
        }

      })
      .catch((err) => {
        toast.error(err);
        setBidCount(0);
        setproductData([]);
      });
    setLoading(1);
  };

  const Handleask = (id) => {
    setAskLoading(0);
    ExportApi.getask(id)
      .then((resp) => {
        setAsk(resp.data.data);
        setAskLoading(1);
      })
      .catch((err) => toast.error(err));
  };

  const Handlebid = (id) => {
    setAskLoading(0);
    ExportApi.getBid(id)
      .then((resp) => {
        setBid(resp.data.data);
        setAskLoading(1);
      })
      .catch((err) => toast.error(err));
  };

  const ASKBID = (id, i) => {
    Handleask(id);
    Handlebid(id);
    setAskBid(i);
  };

  const handleCheck = (data, id) => {
    setUncheckedBox(false);
    if (!loggedInUser) {
      toast.error("Please login first");
      return;
    }

    const updatedList = productData?.map((item) => {
      if (item._id === id) {
        return { ...item, isSelected: data };
      }
      return item;
    });

    // Set the updated product list
    setproductData([...updatedList]);

    if (selectedData.includes(id)) {
      const updatedselecteddata = selectedData.filter(
        (item) => !item.includes(id)
      );
      setSelectedData([...updatedselecteddata]);
    } else {
      setSelectedData([...selectedData, id]);
    }
  };

  const handleUpdateBatch = (data, id) => {
    setLoading(0);
    const ids = id.filter((i) => i !== undefined);
    if (loggedInUser?.id) {
      ExportApi.updateBatch(data, ids, loggedInUser?.id).then((resp) => {
        if (resp?.data?.message == "Batch updated successfully") {
          if (hideBatchStatus == true){
            setHideBatchStatus(false);
          }

          setBidStatus(false);
          setShowBatch(false);
          setAskStatus(false);
          setShowAskBatch(false);
          toast.success("Batch update Successfully");
          HandleGetProductData(null , bidStatus, askStatus);
          setSelectCheckBox(false);
        } else {
          toast.error("Something went wrong!!!! , try again");
        }
      });
    }
  };

  const handleSelectAll = (e) => {
    if (!loggedInUser) {
      toast.error("Please login first");
      return;
    }

    const result = e.target.checked;
    setSelectCheckBox(result);

    const updatedProductData = productData.map((item) => {
      return { ...item, isSelected: result };
    });

    setproductData(updatedProductData);

    if (result) {
      const selectedIds = updatedProductData.map((item) => item._id);
      setSelectedData(selectedIds);
    } else {
      setSelectedData([]);
    }
  };

  //to show the filter Modal
  const handlefilterModal = () => {
    setShowFilterModel(true);
  };

  //get the data of the filter
  const HandleGetFilterListData = () => {
    ExportApi.GetFilterData()
      .then((resp) => {
        let chipsetKeyArray = [];
        let conditionKeyArray = [];
        let brandKeyArray = [];
        let modalKeyArray = [];
        let seriesKeyArray = [];
        resp?.data.data?.chipset?.map((val, i) => {
          let key = { [val]: false };
          chipsetKeyArray.push(key);
        });
        setchipsetKey([...chipsetKeyArray]);
        resp?.data.data?.condition?.map((val) => {
          if (val == 1) {
            let key = { ["New-Retail"]: false };
            conditionKeyArray.push(key);
          } else if (val == 2) {
            let key = { ["New-2nd Hand"]: false };
            conditionKeyArray.push(key);
          } else {
            let key = { ["Used"]: false };
            conditionKeyArray.push(key);
          }
        });
        setconditionKey([...conditionKeyArray]);
        resp?.data.data?.series?.map((val) => {
          let key = { [val]: false };
          seriesKeyArray.push(key);
        });
        setseriesKey([...seriesKeyArray]);
        resp?.data.data?.brands?.map((val) => {
          let key = { [val]: false };

          brandKeyArray.push(key);
        });
        setbrandKey([...brandKeyArray]);
        resp?.data.data?.model?.map((val) => {
          let key = { [val]: false };
          modalKeyArray.push(key);
        });
        setModalKey([...modalKeyArray]);
        setFilterList(resp?.data?.data);
      })
      .catch((err) => toast.error(err));
  };


  
  //search Filter Api
  const SearchFilterCheck = () => {
    ExportApi.GetAllProductFilter(condition, chipset, brand, series, model)
      .then((resp) => {
        setproductData(resp.data.Data);
      })
      .catch((err) => toast.error(err));
  };

  //chipset Filter
  const ChipsetFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);
    if (checked || index === -1) {
      chipset.push(name);
      chipsetKey[i][name] = checked;
      setchipset([...chipset]);
      filtersearch();
    } else {
      chipsetKey[i][name] = checked;
      chipset.splice(index, 1);
      setchipset([...chipset]);

      filtersearch();
    }
  };

  // condition Filter
  const conditionKeyFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked, min } = e.target;
    let number = parseInt(min);
    let index = condition.indexOf(number);
    let index1 = condition1.indexOf(name);
    if (checked || index === -1 || index1 === -1) {
      condition.push(number);
      condition1.push(name);
      conditionKey[i][name] = checked;
      setcondition([...condition]);
      setcondition1([...condition1]);
      filtersearch();
    } else {
      conditionKey[i][name] = checked;
      condition.splice(index, 1);
      setcondition([...condition]);
      condition1.splice(index1, 1);
      setcondition1([...condition1]);
      filtersearch();
    }
  };

  //modal filter
  const modalFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);
    if (checked) {
      model.push(name);
      modalKey[i][name] = checked;
      setmodel([...model]);
      // setTimeout(() => {
      // SearchFilterCheck();
      //});
      filtersearch();
    } else {
      modalKey[i][name] = checked;
      model.splice(index, 1);
      setmodel([...model]);
      //setTimeout(() => {
      //SearchFilterCheck();
      //});
      filtersearch();
    }
  };

  //series filter
  const seriesFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = series.indexOf(name);
    if (checked) {
      series.push(name);
      seriesKey[i][name] = checked;
      setseries([...series]);
      //setTimeout(() => {
      //SearchFilterCheck();
      //});
      filtersearch();
    } else {
      seriesKey[i][name] = checked;
      series.splice(index, 1);
      setseries([...series]);
      //setTimeout(() => {
      //SearchFilterCheck();
      //});
      filtersearch();
    }
  };

  //Brand Filter
  const BrandtFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = brand.indexOf(name);
    if (checked) {
      brand.push(name);
      brandKey[i][name] = checked;
      setbrand([...brand]);
      filtersearch();
    } else {
      brandKey[i][name] = checked;
      brand.splice(index, 1);
      setbrand([...brand]);
      filtersearch();
    }
  };
  // show more chipset Result
  const handlechipsetshowmore = (data) => {
    if (data == "More") {
      setChipsetShow(true);
    } else {
      setChipsetShow(false);
    }
  };

  // show more brand result
  const handlebrandshowmore = (data) => {
    if (data == "More") {
      setBrandShow(true);
    } else {
      setBrandShow(false);
    }
  };

  //show more series result
  const handleSeriesshowmore = (data) => {
    if (data == "More") {
      setSeriesShow(true);
    } else {
      setSeriesShow(false);
    }
  };

  //show more model result
  const handlemodelshowmore = (data) => {
    if (data == "More") {
      setModelShow(true);
    } else {
      setModelShow(false);
    }
  };

  // clear All Filter
  const clearAllFilters = () => {
    HandleGetFilterListData();
    localStorage.setItem("clearFilter", "true");
    localStorage.setItem("pageNumber", "0");
    setPageNumber(0);
    setPageOffset(0);
    setHideBatchStatus(false);
    setBatchData([]); 
    setmodel([]);
    setseries([]);
    setbrand([]);
    setchipset([]);
    setcondition([]);
    setcondition1([]);
    setSortColumn("");
    setSortOrder("");
    setBidStatus(false);
    setAskStatus(false);
    if (loggedInUser?.role == "user") {
      HandleGetProductData();
      HandleGetFilterListData(loggedInUser?.id);
    } else if (loggedInUser?.role == "admin") {
      HandleGetProductData();
      HandleGetFilterListData(loggedInUser?.id);
      HandleGetProductData();
    } else {
      filtersearch();
    }
  };

  //Condition Filter Close
  const conditionKeyFilterClose = (i, name) => {
    let index = 0;
    for (let i = 0; i < conditionKey.length; i++) {
      if (Object.keys(conditionKey[i])[0] == name) {
        index = i;
      }
    }
    conditionKey[index][name] = false;
    condition1.splice(i, 1);
    condition.splice(i, 1);
    setcondition1([...condition1]);
    setcondition([...condition]);
    setPageNumber(0);
    setPageOffset(0);

    filtersearch();
  };

  //Chipset Filter Close
  const ChipsetFilterClose = (id, name) => {
    let index = -1;
    for (let i = 0; i < chipsetKey.length; i++) {
      if (Object.keys(chipsetKey[i])[0] == name) {
        index = i;
      }
    }

    chipsetKey[index][name] = false;
    chipset.splice(id, 1);
    setchipset([...chipset]);
    //setTimeout(() => {
    //SearchFilterCheck();
    //});
    setPageNumber(0);
    setPageOffset(0);
    filtersearch();
  };

  //Brand Filter Close
  const brandtFilterClose = (i, name) => {
    let index = -1;
    for (let i = 0; i < brandKey.length; i++) {
      if (Object.keys(brandKey[i])[0] == name) {
        index = i;
      }
    }
    brandKey[index][name] = false;
    brand.splice(i, 1);
    setbrand([...brand]);
    //setTimeout(() => {
    //SearchFilterCheck();
    //});
    setPageNumber(0);
    setPageOffset(0);
    filtersearch();
  };

  //Series Filter Close
  const seriesFilterCsole = (i, name) => {
    let index = -1;
    for (let i = 0; i < seriesKey.length; i++) {
      if (Object.keys(seriesKey[i])[0] == name) {
        index = i;
      }
    }
    seriesKey[index][name] = false;
    series.splice(i, 1);
    setseries([...series]);
    setPageNumber(0);
    setPageOffset(0);
    filtersearch();
  };

  //modal Filter Close
  const modalFilterCsole = (i, name) => {
    let index = -1;
    for (let i = 0; i < modalKey.length; i++) {
      if (Object.keys(modalKey[i])[0] == name) {
        index = i;
      }
    }
    modalKey[index][name] = false;
    model.splice(i, 1);
    setmodel([...model]);

    //SearchFilterCheck();

    setPageNumber(0);
    setPageOffset(0);
    filtersearch();
  };

  const handleUnBatch = () => {
    if (loggedInUser) {
      if (selectedData?.length != 0) {
            setShowUnbatchLoader(true)
        ExportApi.removeFromBatch(selectedData, loggedInUser?.id, "sell")
          .then((resp) => {
            if (resp?.data?.status == true) {
              toast.success(resp?.data?.message);
              setSelectedData([]);
              setSelectCheckBox(false);
              setShowUnbatchLoader(false);
              HandleGetProductData(null, bidStatus, askStatus);
              // Refresh counts after unbatch operation
              if (loggedInUser?.id) {
                HandleGetAskCount(loggedInUser.id);
                HandleGetBidCount(loggedInUser.id);
              }
            } else {
              toast.error(resp.data.message);
              setShowUnbatchLoader(false);
              setSelectedData([]);
              setSelectCheckBox(false);
            }
          })
          .catch((err) => {
            toast.error(err);
            setShowUnbatchLoader(false);
          });
      } else {
        toast.error("Please Select the Product First");
        setShowUnbatchLoader(false);
      }
    }
    else {
      setShowModal(true);
    }
  }

  const handleCreateBatch = () => {
    if (loggedInUser) {
      if (selectedData?.length != 0) {
        setShowButtonLoader(true);
        ExportApi.createBatch(selectedData, loggedInUser?.id, "sell")
          .then((resp) => {
            if (resp?.data?.status == true) {
              toast.success(resp?.data?.message);
              setSelectedData([]);
              setSelectCheckBox(false);
              setShowButtonLoader(false);
              HandleGetProductData(null, bidStatus, askStatus);
              // Refresh counts after batch operation
              if (loggedInUser?.id) {
                HandleGetAskCount(loggedInUser.id);
                HandleGetBidCount(loggedInUser.id);
              }
            } else {
              toast.error(resp.data.message);
              setShowButtonLoader(false);
              setSelectedData([]);
              setSelectCheckBox(false);
            }
          })
          .catch((err) => {
            toast.error(err);
            setShowButtonLoader(false);
          });
      } else {
        toast.error("Please Select the Product First");
        setShowButtonLoader(false);
      }
    }
    else {
      setShowModal(true);
    }
  };

  const handleHideBatch = () => {
    setHideBatchStatus((prevState) => {
      const newHideBatchStatus = !prevState;
  
      // Now you can use newHideBatchStatus as the updated state
      if (newHideBatchStatus) {  
        if (loggedInUser?.role === "user") {
          HandleGetProductData(null, bidStatus, askStatus);
 
          HandleGetFilterListData();
        } else if (loggedInUser?.role === "admin") {
          HandleGetProductData(null, bidStatus, askStatus);
          HandleGetFilterListData();
        } else {
          HandleGetProductData(0, bidStatus, askStatus);
          HandleGetFilterListData();
        }
      } else {
        let data = productData?.filter((item) => item.batchStatus !== true);
        setproductData([...data]);
      }
  
      return newHideBatchStatus;
    });
  };


  // Load initial product data on mount and when hideBatchStatus changes
  useEffect(() => {
    HandleGetProductData(null, bidStatus, askStatus);
  }, [hideBatchStatus]); 

  const handleBatchStatus = (status) => {
    if (loggedInUser) {
      setHideBatchStatus(!hideBatchStatus);
    } else {
      setShowModal(true);
    }
  };
 
  useEffect(() => {
    HandleGetFilterListData();

    if (loggedInUser?.id) {
      ExportApi.checkBatchStatus(loggedInUser.id)
        .then((resp) => {
          if (resp?.data?.statusCode == 200) {
            setAlreadyCreatedBatch(resp?.data.data.batchStatus);
          }
        })
        .catch((err) => {
          toast.error(err)
        });
      
      // Fetch ask and bid counts on page load - calculate immediately on mount
      // This ensures counts are shown even before clicking My Asks/My Bids
      HandleGetAskCount(loggedInUser.id);
      HandleGetBidCount(loggedInUser.id);
    } else {
      // Reset counts if user is not logged in
      setAskCount(0);
      setBidCount(0);
    }
  }, [loggedInUser]);

  // Update batch count whenever batchData or productData changes
  useEffect(() => {
    // First try to get count from batchData
    let count = batchData?.length || 0;
    
    // If batchData is empty but we have productData, count batch items from productData
    if (count === 0 && productData?.length > 0) {
      count = productData.filter(
        (item) => item.isBatch === true || item.batchStatus === true
      ).length;
    }
    
    setBatchCount(count);
  }, [batchData, productData]);

  // Synchronize scrolling between header and data tables
  useEffect(() => {
    const headerScroll = window.buySellHeaderScroll;
    const dataScroll = dataTableScrollRef.current;

    if (!headerScroll || !dataScroll) return;

    const syncHeaderScroll = () => {
      if (dataScroll.scrollLeft !== headerScroll.scrollLeft) {
        headerScroll.scrollLeft = dataScroll.scrollLeft;
      }
    };

    const syncDataScroll = () => {
      if (headerScroll.scrollLeft !== dataScroll.scrollLeft) {
        dataScroll.scrollLeft = headerScroll.scrollLeft;
      }
    };

    dataScroll.addEventListener('scroll', syncHeaderScroll);
    headerScroll.addEventListener('scroll', syncDataScroll);

    return () => {
      dataScroll.removeEventListener('scroll', syncHeaderScroll);
      headerScroll.removeEventListener('scroll', syncDataScroll);
    };
  }, [productData]);

  const updateBatchButtonClick = () => {
    if (selectedData?.length === 0) {
      toast.error("Please select a product first");
    }
    //  (selectedData?.length >= 2)
    else {
      const uniqueSelectedIds = new Set(selectedData);

      // Use a Map to ensure uniqueness based on _id
      const uniqueProductMap = new Map();
      productData.forEach((item) => {
        if (uniqueSelectedIds.has(item._id)) {
          uniqueProductMap.set(item._id, item); // Keeps only one entry per _id
        }
      });

      // Convert the Map values to an array
      const resultArray = Array.from(uniqueProductMap.values());

      let finalArray = resultArray.map((item) => item?._id);
      // const uniqueBatchids = Array.from(
      //   new Set(batchData?.map((item) => item.productId._id))
      // );
      const uniqueBatchids = Array.from(
        new Set(batchData?.map((item) => item.productId?._id)) // Add optional chaining here
      );
      

      let nonSelected = uniqueBatchids.filter((id) => !finalArray.includes(id));

      let finalArrayToSend;
      if (nonSelected?.length <= 1) {
        finalArrayToSend = [...finalArray, ...nonSelected];
      } else {
        finalArrayToSend = [...finalArray];
      }

      // return;
      // handleUpdateBatch(true, finalArrayToSend);
      setTimeout(() => {
        setUncheckedBox(true);
        setSelectedData([]);
        setSelectCheckBox(false);
      }, 1000);
    }
    // else {

    //   setTimeout(() => {
    //     setUncheckedBox(true);
    //   }, 1000);
    //   toast.error("Please select a Product First");
    // }
  };

  const [askListOrderBook, setAskListOrderBook] = useState();
  const [bidListOrderBook, setBidListOrderBook] = useState();

  const showOrderBook = (product_id) => {
    setLoader(true);
    ExportApi.showOrderBook(product_id)
      .then((resp) => {
        if (resp?.data.statusCode == 200) {
          setLoader(false);

          setAskListOrderBook(resp?.data?.data?.askList);
          setBidListOrderBook(resp?.data?.data?.bidList);

        }else if (resp?.data?.message == "No bids or asks found for this product."){
            setLoader(false);
           setAskListOrderBook(0);
          setBidListOrderBook(0);
        }

      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const handlePageClick = ({ selected }) => {
    setPageNumber(selected);
    setPageOffset(selected);
    setSelectCheckBox(false);
    setSelectedData([]);
    setMainloader(true);
    HandleGetProductData(selected + 1, bidStatus, askStatus)
  };

  const filtersearch = () => {
    setBidStatus(false);
    setAskStatus(false);
    setMainloader(true);
    const data = {
      condition: condition1,
      chipset: chipset,
      brand: brand,
      series: series,
      model: model,
      currentPage: pageNumber + 1,
      searchString: searchString,
      sortColumn,
      sortOrder: sortOrder,
      batch: hideBatchStatus,
      id:loggedInUser?.id
    };

    ExportApi.buysellfilter(data)
      .then((resp) => {
        console.trace();
        const data = resp?.data.Data;
        const totalpages = resp?.data.Total;
        if (hideBatchStatus) {
          const onlyBatchItems = data.filter(item => item.isBatch == true);
          const nonBatchItems = data.filter(item => !item.isBatch || item.isBatch == false);
          setBatchData(onlyBatchItems)
          const finalProducts = hideBatchStatus
            ? [...onlyBatchItems, ...nonBatchItems]
            : data;
          setproductData(finalProducts);
          setTotalPages(totalpages)
        }
        else {
          setTotalPages(totalpages);
          setproductData(data)
        }
        setMainloader(false);

      })
      .catch((err) => {
        setMainloader(false);
      });
  };

  const handleFilterSet = () => {
    filtersearch();

    const selectedCondition = [];
    const selectedChipset = [];
    const selectedBrand = [];
    const selectedSeries = [];
    const selectedModel = [];

    document
      .querySelectorAll('input[name="condition"]:checked')
      .forEach((checkbox) => {
        selectedCondition.push(checkbox.name);
      });

    document
      .querySelectorAll('input[name="chipset"]:checked')
      .forEach((checkbox) => {
        selectedChipset.push(checkbox.name);
      });

    document
      .querySelectorAll('input[name="brand"]:checked')
      .forEach((checkbox) => {
        selectedBrand.push(checkbox.name);
      });

    document
      .querySelectorAll('input[name="series"]:checked')
      .forEach((checkbox) => {
        selectedSeries.push(checkbox.name);
      });

    document
      .querySelectorAll('input[name="model"]:checked')
      .forEach((checkbox) => {
        selectedModel.push(checkbox.name);
      });
  };

  const handleSort = (column) => {
    const newSortOrder =
      sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(newSortOrder);
    
    // If viewing My Asks or My Bids, sort the current filtered data locally
    if (askStatus || bidStatus) {
      const currentData = [...productData];
      const sortedData = currentData.sort((a, b) => {
        let aValue, bValue;
        let aIsInvalid = false;
        let bIsInvalid = false;
        
        // Use feature property from API for dealScore sorting
        if (column === "dealScore") {
          // Check if feature exists and is a valid number
          // Items without a deal score (null, undefined, empty string, string "null", NaN, or non-numeric) MUST go to the end
          const aFeature = a?.feature;
          const bFeature = b?.feature;
          
          // Check if feature is missing or invalid (null, undefined, empty string, string "null", or non-numeric)
          // Also handle the case where feature might be the string "null" or "undefined"
          const aFeatureStr = String(aFeature || "").toLowerCase().trim();
          const bFeatureStr = String(bFeature || "").toLowerCase().trim();
          const aIsStringNull = aFeatureStr === "null" || aFeatureStr === "undefined" || aFeatureStr === "";
          const bIsStringNull = bFeatureStr === "null" || bFeatureStr === "undefined" || bFeatureStr === "";
          
          const aHasDealScore = !aIsStringNull && aFeature != null && aFeature !== "" && !isNaN(Number(aFeature)) && isFinite(Number(aFeature));
          const bHasDealScore = !bIsStringNull && bFeature != null && bFeature !== "" && !isNaN(Number(bFeature)) && isFinite(Number(bFeature));
          
          // Convert to numbers only if valid
          const aNum = aHasDealScore ? Number(aFeature) : null;
          const bNum = bHasDealScore ? Number(bFeature) : null;
          
          // CRITICAL: Items without a deal score MUST go to the end (regardless of sort order)
          if (!aHasDealScore && bHasDealScore) return 1;  // a has no deal score, b has deal score -> a goes to end
          if (aHasDealScore && !bHasDealScore) return -1; // a has deal score, b has no deal score -> b goes to end
          if (!aHasDealScore && !bHasDealScore) return 0;  // both have no deal score -> keep order
          
          // Both have valid deal scores, sort numerically
          aValue = aNum;
          bValue = bNum;
          
          // Numeric comparison for dealScore
          if (aValue < bValue) return newSortOrder === "asc" ? -1 : 1;
          if (aValue > bValue) return newSortOrder === "asc" ? 1 : -1;
          return 0;
        } else if (column === "lowest_ask" || column === "highest_bid") {
          // Handle lowest_ask and highest_bid sorting
          // Get raw values first to check for strings
          const aRaw = a[column];
          const bRaw = b[column];
          
          // Check if raw value is a string (like "TBD") or non-numeric
          const aIsString = typeof aRaw === "string" && (aRaw === "" || aRaw.trim() === "" || isNaN(Number(aRaw)));
          const bIsString = typeof bRaw === "string" && (bRaw === "" || bRaw.trim() === "" || isNaN(Number(bRaw)));
          
          // Convert to numbers for proper numeric comparison (handles string numbers)
          const aNum = aRaw != null && aRaw !== "" && !aIsString ? Number(aRaw) : null;
          const bNum = bRaw != null && bRaw !== "" && !bIsString ? Number(bRaw) : null;
          
          // Check if values are invalid: null, undefined, NaN, empty string, non-numeric strings, or values less than 1
          // Only values >= 1 are considered valid for sorting
          aIsInvalid = aNum == null || isNaN(aNum) || aIsString || aNum < 1;
          bIsInvalid = bNum == null || isNaN(bNum) || bIsString || bNum < 1;
          
          // CRITICAL: Invalid values (TBD, 0, null, etc.) should ALWAYS be at the end
          // Return 1 means 'a' goes after 'b' (to the end)
          // Return -1 means 'a' goes before 'b' (to the front)
          if (aIsInvalid && !bIsInvalid) return 1;  // a is invalid, b is valid -> a goes to end
          if (!aIsInvalid && bIsInvalid) return -1; // a is valid, b is invalid -> b goes to end (a stays)
          if (aIsInvalid && bIsInvalid) return 0;    // both invalid -> keep order
          
          // Both are valid numeric values (>= 1), sort numerically
          if (aNum < bNum) return newSortOrder === "asc" ? -1 : 1;
          if (aNum > bNum) return newSortOrder === "asc" ? 1 : -1;
          return 0;
        } else {
          aValue = a[column];
          bValue = b[column];
        }
        
        // Handle null/undefined values (for non-dealScore, non-ask/bid columns)
        if (column !== "dealScore" && column !== "lowest_ask" && column !== "highest_bid") {
          if (aValue == null) aValue = "";
          if (bValue == null) bValue = "";
        }
        
        // Convert to string for comparison if both are strings (but not for dealScore or ask/bid)
        if (column !== "dealScore" && column !== "lowest_ask" && column !== "highest_bid" && typeof aValue === "string" && typeof bValue === "string") {
          return newSortOrder === "asc" 
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }
        
        // Numeric comparison (works for other numeric columns)
        if (column !== "dealScore" && column !== "lowest_ask" && column !== "highest_bid") {
          if (aValue < bValue) return newSortOrder === "asc" ? -1 : 1;
          if (aValue > bValue) return newSortOrder === "asc" ? 1 : -1;
          return 0;
        }
        
        return 0;
      });
      
      // Maintain batch separation if hideBatchStatus is true
      if (hideBatchStatus && askStatus) {
        const onlyBatchItems = sortedData.filter(item => item.batchStatus == true);
        const nonBatchItems = sortedData.filter(item => !item.batchStatus || item.batchStatus == false);
        setBatchData(onlyBatchItems);
        const finalProducts = [...onlyBatchItems, ...nonBatchItems];
        setproductData(finalProducts);
      } else if (hideBatchStatus && bidStatus) {
        const onlyBatchItems = sortedData.filter(item => item.batchStatus == true);
        const nonBatchItems = sortedData.filter(item => !item.batchStatus || item.batchStatus == false);
        setBatchData(onlyBatchItems);
        const finalProducts = [...onlyBatchItems, ...nonBatchItems];
        setproductData(finalProducts);
      } else {
        setproductData(sortedData);
      }
      return;
    }
    
    // Otherwise, fetch sorted data from API
    fetchSortedData(column, newSortOrder);
  };
  
  const fetchSortedData = async (column, order) => {
    const data = {
      condition: condition1 || [],
      chipset: chipset || [],
      brand: brand || [],
      series: series || [],
      model: model || [],
      currentPage: pageNumber + 1,
      searchString: searchString,
      sortColumn: column,
      sortOrder: order,
      batch: hideBatchStatus,
      id: loggedInUser?.id
    };

    try {
      setMainloader(true);
      const resp = await ExportApi.buysellfilter(data);
      let sortdataall = resp?.data?.Data || [];
      const totalpages = resp?.data?.Total;
      setTotalPages(totalpages);
      
      // Sort locally for dealScore using feature property from API
      // Items without a deal score MUST go to the end of the list
      if (column === "dealScore" && sortdataall.length > 0) {
        sortdataall = sortdataall.sort((a, b) => {
          // Check if feature exists and is a valid number
          const aCalc = a?.feature != null && !isNaN(a.feature) ? Number(a.feature) : null;
          const bCalc = b?.feature != null && !isNaN(b.feature) ? Number(b.feature) : null;

          const aIsInvalid = aCalc === null || aCalc === undefined || isNaN(aCalc);
          const bIsInvalid = bCalc === null || bCalc === undefined || isNaN(bCalc);
          
          // CRITICAL: Items without a deal score MUST go to the end (regardless of sort order)
          if (aIsInvalid && !bIsInvalid) return 1;  // a has no deal score, b has deal score -> a goes to end
          if (!aIsInvalid && bIsInvalid) return -1; // a has deal score, b has no deal score -> b goes to end
          if (aIsInvalid && bIsInvalid) return 0;    // both have no deal score -> keep order

          // Both have valid deal scores, sort numerically
          const aValue = aCalc;
          const bValue = bCalc;

          // Numeric comparison for dealScore
          if (aValue < bValue) return order === "asc" ? -1 : 1;
          if (aValue > bValue) return order === "asc" ? 1 : -1;
          return 0;
        });
      }
      
      // Sort locally for lowest_ask and highest_bid to ensure items without values are at the end
      if ((column === "lowest_ask" || column === "highest_bid") && sortdataall.length > 0) {
        sortdataall = sortdataall.sort((a, b) => {
          // Get raw values first to check for strings
          const aRaw = a[column];
          const bRaw = b[column];
          
          // Check if raw value is a string (like "TBD") or non-numeric
          const aIsString = typeof aRaw === "string" && (aRaw === "" || aRaw.trim() === "" || isNaN(Number(aRaw)));
          const bIsString = typeof bRaw === "string" && (bRaw === "" || bRaw.trim() === "" || isNaN(Number(bRaw)));
          
          // Convert to numbers for proper numeric comparison (handles string numbers)
          const aNum = aRaw != null && aRaw !== "" && !aIsString ? Number(aRaw) : null;
          const bNum = bRaw != null && bRaw !== "" && !bIsString ? Number(bRaw) : null;
          
          // Check if values are invalid: null, undefined, NaN, empty string, non-numeric strings, or values less than 1
          // Only values >= 1 are considered valid for sorting
          const aIsInvalid = aNum == null || isNaN(aNum) || aIsString || aNum < 1;
          const bIsInvalid = bNum == null || isNaN(bNum) || bIsString || bNum < 1;
          
          // CRITICAL: Invalid values (TBD, 0, null, etc.) should ALWAYS be at the end
          // Return 1 means 'a' goes after 'b' (to the end)
          // Return -1 means 'a' goes before 'b' (to the front)
          if (aIsInvalid && !bIsInvalid) return 1;  // a is invalid, b is valid -> a goes to end
          if (!aIsInvalid && bIsInvalid) return -1; // a is valid, b is invalid -> b goes to end (a stays)
          if (aIsInvalid && bIsInvalid) return 0;    // both invalid -> keep order
          
          // Both are valid numeric values (>= 1), sort numerically in the specified order
          if (aNum < bNum) return order === "asc" ? -1 : 1;
          if (aNum > bNum) return order === "asc" ? 1 : -1;
          return 0;
        });
      }
      
      if (hideBatchStatus) {
        const onlyBatchItems = sortdataall.filter(item => item.isBatch == true);
        const nonBatchItems = sortdataall.filter(item => !item.isBatch || item.isBatch == false);
        setBatchData(onlyBatchItems);
        const finalProducts = [...onlyBatchItems, ...nonBatchItems];
        setproductData(finalProducts);
      } else {
        setproductData(sortdataall);
        setBatchData([]);
      }
      setMainloader(false);
    } catch (error) {
      setMainloader(false);
    }
  };

  return (
    <div>
       <Helmet>
        <title>{seoData?.metaTitle ?? "Buy & Sell Marketplace"}</title>
        <meta name="description" content={seoData?.metaDescription ?? "Buy and sell GPUs instantly"} />
        {seoData?.metaImage && <meta property="og:image" content={seoData?.metaImage} />}
      </Helmet>



      <Header
      //hideData={hideData}
      />
      <UserBuybaner
        handleSearch={handleSearch}
        handleUnBatch={handleUnBatch}
        showUnbatchLoader={showUnbatchLoader}
        handleCreateBatch={handleCreateBatch}
        showButtonLoader={showButtonLoader}
        htmlString={htmlString}
        hideBatchStatus={hideBatchStatus}
        handleBatchStatus={handleBatchStatus}
        batchCount={batchCount}
        bidStatus={bidStatus}
        handleViewBid={handleViewBid}
        bidCount={bidCount}
        askStatus={askStatus}
        handleViewAsk={handleViewAsk}
        askCount={askCount}
        filterCount={filterCount}
        handlefilterModal={handlefilterModal}
        selectCheckBox={selectCheckBox}
        handleSelectAll={handleSelectAll}
        handleSort={handleSort}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
      />
      <div className="container">
        {/* <Row className="buy-sell-part">
          <Col lg={12} md={12}>
            <div className="bg-dark p-3 d-md-flex align-items-center justify-content-between rounded mt-3">
              <div className="d-flex align-items-center justify-content-between search-box">
                <h4 className="mb-0 text-white me-3 fw-bold text-nowrap">
                  Buy/Sell
                </h4>
                <Form.Control
                  type="search"
                  placeholder="Search from GPUs below"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
              <div>

                <Button
                  className="bg-light text-black border-0 mb-2 mb-xl-0 mx-1 text-capitalize"
                  onClick={handleUnBatch}
                >
                  {showUnbatchLoader ? "Please Wait..." : "Unbatch"}
                  <ReactTooltip
                    className="custom-tooltip_buy-sell"
                    anchorId="app-batch-buying-tab"
                    place="bottom"
                    clickable={true}
                    closeOnScroll={false}
                    content={
                      <div
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                      />
                    }
                    style={{ textTransform: "none" }}
                  />
                </Button>

                <Button
                  className="bg-light text-black border-0 mb-2 mb-xl-0 mx-1 text-capitalize"
                  onClick={handleCreateBatch}
                >
                  {showButtonLoader ? "Please Wait..." : "Batch"}
                  <ReactTooltip
                    className="custom-tooltip_buy-sell"
                    anchorId="app-batch-buying-tab"
                    place="bottom"
                    clickable={true}
                    closeOnScroll={false}
                    content={
                      <div
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                      />
                    }
                    style={{ textTransform: "none" }}
                  />
                 <QuestionMarkSvg/>
                </Button>

                <Button
                  className={`border-0 mb-2 mb-xl-0 mx-2 text-capitalize ${hideBatchStatus ? "bg-success text-white" : "bg-light text-black"
                    }`}
                  onClick={handleBatchStatus}
                >
                  {hideBatchStatus ? `Hide Batch (${batchCount || 0})` : `Show Batch (${batchCount || 0})`}
                </Button>
                <Button
                  className={`border-0 mb-2 mb-xl-0 text-capitalize ${bidStatus ? "bg-success text-white" : "bg-light text-black"
                    }`}
                  onClick={handleViewBid}
                >
                  My Bids ({bidCount})
                </Button>
                <Button
                  className={`border-0 mb-2 mb-xl-0 mx-2 text-capitalize ${askStatus ? "bg-success text-white" : "bg-light text-black"
                    }`}
                  onClick={handleViewAsk}
                >
                  My Asks ({askCount})
                </Button>

                <Button
                  className="bg-light text-black border-0 mb-2 mb-xl-0 px-5 text-capitalize"
                  onClick={() => handlefilterModal()}
                >
                  Filters ({filterCount})
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={12} className="text-start mt-5"></Col>
        </Row> */}
        {/* {loading == 0 ? (
          <>
            <div className="loader-icon" style={{ marginBlock: "80px" }}>
              <i className="fa-solid fa-spinner fa-spin-pulse"></i>
            </div>

          </>
        ) : (
          <> */}
          {(condition.length > 0 || 
            chipset.length > 0 || 
            brand.length > 0 || 
            series.length > 0 || 
            model.length > 0 || 
            bidStatus || 
            askStatus || 
            filterCount > 0) && (
        <div
          //className="text-center text-sm-start"
          className="text-center text-sm-start d-flex flex-wrap gap-2 p-2"
        >
            <Button
              className="clear-all-filters-btn"
              onClick={() => clearAllFilters()}
            >
              Clear all filters
            </Button>
          {conditionKey.map((val, i) => {
            let key = condition1[i];
            let data = conditionKey.filter((item) => item[key] == true);
            return (
              <>
                {data.length != 0 ? (
                  <span
                    key={i}
                    className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6 d-inline-flex align-items-center gap-2 rounded-pill ${
                      !showMore.showLess ? "custom-childspan" : ""
                    }`}
                    style={{ borderRadius: '50px' }}
                  >
                    {condition1[i]}{" "}
                    <Button
                      className="bg-none border-0 py-0 text-dark p-0"
                      onClick={() => conditionKeyFilterClose(i, condition1[i])}
                      style={{ fontSize: '16px', lineHeight: '1' }}
                    >
                      X
                    </Button>
                  </span>
                ) : null}
              </>
            );
          })}
          {chipsetKey.map((val, i) => {
            let key = chipset[i];
            let data = chipsetKey.filter((item) => item[key] == true);
            return (
              <>
                {data.length != 0 ? (
                  <>
                    <span
                      key={i}
                      className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6 d-inline-flex align-items-center gap-2 rounded-pill ${
                        !showMore.showLess ? "custom-childspan" : ""
                      }`}
                      style={{ borderRadius: '50px' }}
                    >
                      {chipset[i]}{" "}
                      <Button
                        className="bg-none border-0 py-0 text-dark p-0"
                        onClick={() => ChipsetFilterClose(i, chipset[i])}
                        style={{ fontSize: '16px', lineHeight: '1' }}
                      >
                        X
                      </Button>
                    </span>
                  </>
                ) : (
                  ""
                )}
              </>
            );
          })}
          {brandKey?.map((val, i) => {
            let key = brand[i];
            let data = brandKey.filter((item) => item[key] == true);
            return (
              <>
                {data.length != 0 ? (
                  <span
                    key={i}
                    className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6 d-inline-flex align-items-center gap-2 rounded-pill ${
                      !showMore.showLess ? "custom-childspan" : ""
                    }`}
                    style={{ borderRadius: '50px' }}
                  >
                    {brand[i]}{" "}
                    <Button
                      className="bg-none border-0 py-0 text-dark p-0"
                      onClick={() => brandtFilterClose(i, brand[i])}
                      style={{ fontSize: '16px', lineHeight: '1' }}
                    >
                      X
                    </Button>
                  </span>
                ) : null}
              </>
            );
          })}
          {seriesKey.map((val, i) => {
            let key = series[i];
            let data = seriesKey.filter((item) => item[key] == true);
            return (
              <>
                {data.length != 0 ? (
                  <span
                    key={i}
                    className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6 d-inline-flex align-items-center gap-2 rounded-pill ${
                      !showMore.showLess ? "custom-childspan" : ""
                    }`}
                    style={{ borderRadius: '50px' }}
                  >
                    {series[i]}{" "}
                    <Button
                      className="bg-none border-0 py-0 text-dark p-0"
                      onClick={() => seriesFilterCsole(i, series[i])}
                      style={{ fontSize: '16px', lineHeight: '1' }}
                    >
                      X
                    </Button>
                  </span>
                ) : null}
              </>
            );
          })}
          {modalKey.map((val, i) => {
            let key = model[i];
            let data = modalKey.filter((item) => item[key] == true);
            return (
              <>
                {data?.length != 0 ? (
                  <span
                    key={i}
                    className={`bg-custom-light border px-3 py-2 text-center fw-500 fs-6 d-inline-flex align-items-center gap-2 rounded-pill ${
                      !showMore.showLess ? "custom-childspan" : ""
                    }`}
                    style={{ borderRadius: '50px' }}
                  >
                    {model[i]}{" "}
                    <Button
                      className="bg-none border-0 py-0 text-dark p-0"
                      onClick={() => modalFilterCsole(i, model[i])}
                      style={{ fontSize: '16px', lineHeight: '1' }}
                    >
                      X
                    </Button>
                  </span>
                ) : null}
              </>
            );
          })}
          {showMore.showMore && (
            <button
              className="btn btn-link"
              onClick={() =>
                setShowMore((prev) => ({
                  ...prev,
                  showMore: false,
                  showLess: true,
                }))
              }
            >
              Show More
            </button>
          )}
          {showMore.showLess && (
            <button
              className="btn btn-link"
              onClick={() =>
                setShowMore((prev) => ({
                  ...prev,
                  showLess: false,
                  showMore: true,
                }))
              }
            >
              Show Less
            </button>
          )}
        </div>
          )}

        <div className="table-responsive custom-table mb-5" ref={dataTableScrollRef}>
          <div className="gap-2 h-100">
            <Table
              bordered
              striped
              className="align-middle graphic-table by-sell-table "
            >
              {/* <thead className="d-none">
                <tr>
                  <th></th>
                  <th>
                    <div className="text-start d-flex align-items-center gap-2">
                      <Form.Check
                        className="d-inline buysellp"
                        type="checkbox"
                        checked={selectCheckBox}
                        onClick={(e) => handleSelectAll(e)}
                      />
                      <label>Select All</label>
                    </div>
                  </th>
                  <th onClick={() => handleSort("dealScore")}>
                    <div className="d-flex align-items-center">
                      Deal Score
                      <SortSvg sortColumn={sortColumn}/>
                    </div>
                  </th>
                  <th onClick={() => handleSort("brand")}>
                    <div className="d-flex align-items-center">
                      Brand
                      <SortSvg sortColumn={sortColumn}/>
                    </div>
                  </th>
                  <th onClick={() => handleSort("series")}>
                    <div className="d-flex align-items-center">
                      Series
                      <SortSvg sortColumn={sortColumn}/>
                    </div>
                  </th>
                  <th onClick={() => handleSort("model")}>
                    <div className="d-flex align-items-center">
                      Model
                      <SortSvg sortColumn={sortColumn}/>
                    </div>
                  </th>
                  <th onClick={() => handleSort("highest_bid")}>
                    <div className="d-flex align-items-center">
                      Highest Bid
                      <SortSvg sortColumn={sortColumn}/>
                    </div>
                  </th>
                  <th onClick={() => handleSort("lowest_ask")}>
                    <div className="d-flex align-items-center">
                      Lowest Ask
                      <SortSvg sortColumn={sortColumn}/>
                    </div>
                  </th>
                  <th>Your Ask/Bid</th>
                </tr>
              </thead> */}

              <tbody>
                {mainloader == true ? (
                  <>

                    <tr>

                     <td colSpan="9" style={{ textAlign: "center", padding: "40px 0" }}>
                    <div className="loader-icon ">
                      <i className="fa-solid fa-spinner fa-spin-pulse fs-1"></i>
                    </div>
                  </td>
                </tr>

                  </>
                ) : (
                    <>
                      {productData?.length > 0 ? (
                        productData.map((val, i) => {
                          return (
                            <tr key={i}>
                              {hideBatchStatus && (val.isBatch || val.batchStatus) ? (
                                i === 0 ? (
                                  <td rowSpan={batchData.length} className="fst-part-cont">
                                    <div className="bg-dark lft-bar text-white mr-1 d-flex align-items-center">
                                      <p className="vertical-text">BATCH</p>
                                    </div>
                                  </td>
                                ) : null
                              ) : (
                                <td style={{ maxWidth: 0, width: 0, padding: 0 }}></td>
                              )}

                              <td className="">
                                <div className="d-flex align-items-start gap-2">
                                  <div className="buysellimg">
                                    <img
                                      src={
                                        val?.image?.[0] ||
                                        val?.productId?.image?.[0]
                                      }
                                      style={{
                                        cursor: "pointer",
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                      }}
                                      onClick={() =>
                                        window.open(
                                          `/product/${val.slug}`,
                                          "_blank"
                                        )
                                      }
                                    />
                                  </div>
                                  
                                  <div className="d-flex flex-column gap-1">
                                    <span
                                      style={{ cursor: "default", color: "rgb(11, 64, 104)", lineHeight: "1.2" }}
                                    >
                                      {
                                        val?.type == 2 ? "New" : "Used"
                                      }
                                    </span>
                                    
                                    <Button
                                      className="bg-none border-0 p-0"
                                      style={{ lineHeight: "1", padding: "0" }}
                                      onClick={() => setdescriptionindex(descriptionindex === i ? null : i)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#0000ff"
                                        className="bi bi-chevron-down"
                                        viewBox="0 0 16 16"
                                        style={{
                                          transform: descriptionindex === i ? 'rotate(180deg)' : 'rotate(0deg)',
                                          transition: 'transform 0.2s ease'
                                        }}
                                      >
                                        <path
                                          filerule="evenodd"
                                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                        />
                                      </svg>
                                    </Button>

                                    <Form.Check
                                      className="d-inline buysellp"
                                      type="checkbox"
                                      style={{ marginTop: "2px" }}
                                      checked={
                                        selectedData?.includes(val?._id) || false
                                      }
                                      onClick={(e) =>
                                        handleCheck(e.target.checked, val?._id)
                                      }
                                    />
                                  </div>
                                </div>
                              
                                <OutsideClickHandler
                                  onOutsideClick={(e) => {
                                    if (descriptionindex === i && !e.target.closest(".modal_custom_")) {
                                      setdescriptionindex(null);
                                    }
                                  }}
                                >
                                  <div className="tool_tip_custom custom">
                                    {descriptionindex == i ? (
                                      <div
                                        className="modal_custom_ dropdownmodalcss condition-dropdown-responsive"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      >
                                        <div className="inner_customModal_one">
                                          <h5
                                            dangerouslySetInnerHTML={{
                                              __html: `${val?.description
                                                  ? val?.description.substring(
                                                    0,
                                                    1500
                                                  )
                                                  : "No product description"
                                                }${val?.description?.length > 1500
                                                  ? "..."
                                                  : ""
                                                }`,
                                            }}
                                          ></h5>
                                          {val?.description?.length > 50 ? (
                                            <a
                                              onClick={() =>
                                                navigate(`/product/${val.slug}`)
                                              }

                                              style={{ cursor: 'pointer' }}

                                            >
                                              See more
                                            </a>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </OutsideClickHandler>
                              </td>

                            <td>
                              <div style={{ cursor: "default", textAlign: "center" }}>
                              {/* API Response Value */}
                                {val?.feature && val?.feature?.toFixed(2) !== "null" ? val?.feature?.toFixed(2) : "Not Available"}
                          
                                {/* Manual Calculate value code from categories.jsx 4321*/}
                                  {/* {val?.benchmark_score && val?.lowest_ask > 0 && isFinite(val.benchmark_score / val.lowest_ask) ? (val.benchmark_score / val.lowest_ask).toFixed(2) : "Not Available"}  */}
                              </div>
                            </td>
                            <td>
                              <div style={{ cursor: "default", textAlign: "center" }}>
                                {val?.brand}
                              </div>
                            </td>
                            <td>
                              <div style={{ cursor: "default", textAlign: "center" }}>
                                {val?.series}
                              </div>
                            </td>

                            <td>
                              <div
                                className="text-breakdown"
                                style={{ cursor: "default", textAlign: "center" }}
                                title={val.model}
                              >
                                {val?.model}
                              </div>
                            </td>

                            <td>
                              <div className="d-flex justify-content-center">
                                {val?.type != 1 ? (
                                  <Button
                                    className="border bg-danger border-0 rounded-pill"
                                    style={{ backgroundColor: "#990000", borderRadius: "50px", padding: "6px 16px" }}
                                    onClick={() =>
                                      window.open(
                                        "/bidask/" + val?.slug + "/sell",
                                        "_blank"
                                      )
                                    }
                                    disabled={(val?.highest_bid && val?.highest_bid > 0) || (val?.bidPrice && val?.bidPrice > 0) ? false : true}
                                  >
                                    Sell Now {((val?.highest_bid && val?.highest_bid > 0) || (val?.bidPrice && val?.bidPrice > 0))
                                      ? "$" + (val?.highest_bid || val?.bidPrice)
                                      : "TBD"}
                                  </Button>
                                ) : (
                                  <span style={{ color: "#999" }}>-</span>
                                )}
                              </div>
                            </td>

                            <td>
                              <div className="d-flex justify-content-center">
                                {val?.type == 1 ? (
                                  <Button
                                    className="border bg-success border-0 rounded-pill"
                                    style={{ backgroundColor: "#225e40", borderRadius: "50px", padding: "6px 16px" }}
                                    onClick={() =>
                                      window.open(
                                        "/bidask/" + val?.slug + "/buy",
                                        "_blank"
                                      )
                                    }
                                    disabled={
                                      val.new_retail_website_price > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Buy Now ${val?.new_retail_website_price}
                                  </Button>
                                ) : (
                                  <Button
                                    className="border bg-success border-0 rounded-pill"
                                    style={{ backgroundColor: "#225e40", borderRadius: "50px", padding: "6px 16px" }}
                                    onClick={() =>
                                      window.open(
                                        "/bidask/" + val?.slug + "/buy",
                                        "_blank"
                                      )
                                    }
                                    disabled={
                                      (val?.lowest_ask && val?.lowest_ask > 0) || (val?.askPrice && val?.askPrice > 0) ? false : true
                                    }
                                  >
                                    Buy Now {askStatus
                                      ? val?.askAmount > 0
                                        ? "$" + val?.askAmount
                                        : "TBD"
                                      : ((val?.lowest_ask && val?.lowest_ask > 0) || (val?.askPrice && val?.askPrice > 0))
                                        ? "$" + (val?.lowest_ask || val?.askPrice)
                                        : "TBD"}
                                  </Button>
                                )}
                                {descriptionindex1 == i && (
                                  <OutsideClickHandler
                                    onOutsideClick={(e) => {
                                      // Close Order Book modal when clicking outside
                                      if (descriptionindex1 === i && !e.target.closest('#bid_ask_model')) {
                                        setdescriptionindex1(null);
                                      }
                                    }}
                                  >
                                    <div
                                      className="inner_customModal custom-tab-mode"
                                      id="bid_ask_model"
                                      style={{ position: 'absolute', zIndex: 10, backgroundColor: '#fff', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                                    >
                                      {loader ? (
                                        <div
                                          className="loader-icon loader-icon1"
                                          style={{
                                            height: "50px",
                                            width: "90px",
                                          }}
                                        >
                                          <i
                                            className="fa-solid fa-spinner fa-spin-pulse"
                                            style={{ marginTop: "80px" }}
                                          ></i>
                                        </div>
                                      ) : (
                                        <div className="d-flex gap-3" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '12px' }}>
                                          <div className="table-responsive-sm" style={{ flex: '1', minWidth: '0', width: '50%' }}>
                                            <table className="table table-striped table-bordered table-hover" style={{ width: '100%', tableLayout: 'fixed', margin: '0', borderCollapse: 'collapse' }}>
                                              <thead>
                                                <tr>
                                                  <th style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>Qty</th>
                                                  <th style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>Bid</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {bidListOrderBook?.length >
                                                0 ? (
                                                  bidListOrderBook?.map(
                                                    (item, idx) => (
                                                      <tr key={idx}>
                                                        <td style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>
                                                          {item?.quantity}
                                                        </td>
                                                        <td style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>
                                                          ${item?.bidAmount}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td colSpan="2" style={{ textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>No Bids</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                          <div className="table-responsive-sm" style={{ flex: '1', minWidth: '0', width: '50%' }}>
                                            <table className="table table-striped table-bordered table-hover" style={{ width: '100%', tableLayout: 'fixed', margin: '0', borderCollapse: 'collapse' }}>
                                              <thead>
                                                <tr>
                                                  <th style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>Qty</th>
                                                  <th style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>Ask</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {askListOrderBook?.length >
                                                0 ? (
                                                  askListOrderBook?.map(
                                                    (item, idx) => (
                                                      <tr key={idx}>
                                                        <td style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>
                                                          {item?.quantity}
                                                        </td>
                                                        <td style={{ width: '50%', textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>
                                                          ${item?.askAmount}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td colSpan="2" style={{ textAlign: 'center', padding: '8px', verticalAlign: 'middle' }}>No Asks</td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </OutsideClickHandler>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center">
                                {val?.type === 1 ? (
                                  <span style={{ color: "#999" }}>Retail Only</span>
                                ) : ((val?.bidAmount && val?.bidAmount > 0) || (val?.askAmount && val?.askAmount > 0)) ? (
                                  <OutsideClickHandler
                                    onOutsideClick={(e) => {
                                      // Close dropdown when clicking outside, but not on the dropdown itself
                                      if (openPlaceBidDropdown === i && !e.target.closest('.order-book-dropdown')) {
                                        setOpenPlaceBidDropdown(null);
                                      }
                                    }}
                                  >
                                    <div className="position-relative d-inline-flex">
                                      <div className="d-flex align-items-center" style={{ gap: '0px' }}>
                                          {(val?.askAmount && val?.askAmount > 0) && (
                                          <Button 
                                            className="border bg-danger rounded-pill" 
                                            style={{ 
                                              backgroundColor: "#225e40", 
                                              borderRadius: (val?.bidAmount && val?.bidAmount > 0) ? '50px 0 0 50px' : '50px', 
                                              padding: '6px 16px',
                                              borderRight: (val?.bidAmount && val?.bidAmount > 0) ? 'none' : '1px solid #dee2e6'
                                            }}
                                            onClick={() =>
                                              window.open("/bidask/" + val?.slug, "_blank")
                                            }
                                          >
                                            {"$" + val?.askAmount}
                                          </Button>
                                        )}
                                        {(val?.bidAmount && val?.bidAmount > 0) && (
                                          <Button 
                                            className="border bg-success rounded-pill" 
                                            style={{ 
                                              backgroundColor: "#990000", 
                                              borderRadius: (val?.askAmount && val?.askAmount > 0) ? '0 50px 50px 0' : '50px', 
                                              padding: '6px 16px',
                                              borderLeft: (val?.askAmount && val?.askAmount > 0) ? 'none' : '1px solid #dee2e6'
                                            }}
                                            onClick={() =>
                                              window.open("/bidask/" + val?.slug, "_blank")
                                            }
                                          >
                                            {"$" + val?.bidAmount}
                                          </Button>
                                        )}
                                        <Button
                                          className="bg-none border-0 p-0"
                                          style={{ minWidth: 'auto', padding: '0 !important', marginLeft: '4px' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            // Immediately show Order Book when arrow is clicked
                                            if (descriptionindex1 === i) {
                                              // If Order Book is already open, close it
                                              setdescriptionindex1(null);
                                            } else {
                                              // Show Order Book directly
                                              showOrderBook(val?._id);
                                              setdescriptionindex1(i);
                                            }
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="#0000ff"
                                            className="bi bi-chevron-down"
                                            viewBox="0 0 16 16"
                                            style={{
                                              transform: descriptionindex1 === i ? 'rotate(180deg)' : 'rotate(0deg)',
                                              transition: 'transform 0.2s ease'
                                            }}
                                          >
                                            <path
                                              filerule="evenodd"
                                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                            />
                                          </svg>
                                        </Button>
                                      </div>
                                    </div>
                                  </OutsideClickHandler>
                                ) : val?.bidPrice == null ||
                                  val?.askPrice == null ? (
                                  <OutsideClickHandler
                                    onOutsideClick={(e) => {
                                      // Close dropdown when clicking outside, but not on the dropdown itself
                                      if (openPlaceBidDropdown === i && !e.target.closest('.order-book-dropdown')) {
                                        setOpenPlaceBidDropdown(null);
                                      }
                                    }}
                                  >
                                    <div className="position-relative d-inline-flex">
                                      <div className="d-flex align-items-center gap-1" style={{ paddingRight : '5px' }}>
                                        {(val?.bidAmount && val?.bidAmount > 0) || (val?.askAmount && val?.askAmount > 0) ? (
                                          <>
                                            {(val?.askAmount && val?.askAmount > 0) && (
                                              <Button 
                                                className="border bg-success rounded-pill" 
                                                style={{ 
                                                  backgroundColor: "#225e40", 
                                                  borderRadius: (val?.bidAmount && val?.bidAmount > 0) ? '50px 0 0 50px' : '50px', 
                                                  padding: '6px 16px',
                                                  borderRight: (val?.bidAmount && val?.bidAmount > 0) ? 'none' : '1px solid #dee2e6'
                                                }}
                                                onClick={() =>
                                                  window.open("/bidask/" + val?.slug, "_blank")
                                                }
                                              >
                                                {"$" + val?.askAmount}
                                              </Button>
                                            )}
                                            {(val?.bidAmount && val?.bidAmount > 0) && (
                                              <Button 
                                                className="border bg-danger rounded-pill" 
                                                style={{ 
                                                  backgroundColor: "#990000", 
                                                  borderRadius: (val?.askAmount && val?.askAmount > 0) ? '0 50px 50px 0' : '50px', 
                                                  padding: '6px 16px',
                                                  borderLeft: (val?.askAmount && val?.askAmount > 0) ? 'none' : '1px solid #dee2e6'
                                                }}
                                                onClick={() =>
                                                  window.open("/bidask/" + val?.slug, "_blank")
                                                }
                                              >
                                                {"$" + val?.bidAmount}
                                              </Button>
                                            )}
                                          </>
                                        ) : (
                                          <Button
                                            className="border bg-light text-dark border-dark rounded-pill"
                                            style={{ backgroundColor: '#e9ecef', borderColor: '#dee2e6', borderRadius: '50px', padding: '6px 16px' }}
                                            onClick={() =>
                                              window.open("/bidask/" + val?.slug, "_blank")
                                            }
                                          >
                                            Place Bid/Ask
                                          </Button>
                                        )}
                                        <Button
                                          className="bg-none border-0 p-0"
                                          style={{ minWidth: 'auto', padding: '0 !important' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            // Immediately show Order Book when arrow is clicked
                                            if (descriptionindex1 === i) {
                                              // If Order Book is already open, close it
                                              setdescriptionindex1(null);
                                            } else {
                                              // Show Order Book directly
                                              showOrderBook(val?._id);
                                              setdescriptionindex1(i);
                                            }
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="#0000ff"
                                            className="bi bi-chevron-down"
                                            viewBox="0 0 16 16"
                                            style={{
                                              transform: descriptionindex1 === i ? 'rotate(180deg)' : 'rotate(0deg)',
                                              transition: 'transform 0.2s ease'
                                            }}
                                          >
                                            <path
                                              filerule="evenodd"
                                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                            />
                                          </svg>
                                        </Button>
                                      </div>
                                    </div>
                                  </OutsideClickHandler>
                                ) : (
                                  <div className="d-flex gap-2 justify-content-center">
                                    <Button className="border bg-danger rounded-pill" style={{ backgroundColor: "#990000", borderRadius: '50px', padding: '6px 16px' }}>
                                      {"$" + val?.bidPrice}
                                    </Button>
                                    <Button className="border bg-success rounded-pill" style={{ backgroundColor: "#225e40", borderRadius: '50px', padding: '6px 16px' }}>
                                      {"$" + val?.askPrice}
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <span>No Product Found</span>
                    )}  

                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        {/* <div className="pagination_box"> */}
        <div className="pagination_wrapper">
          {/* {totalPages >= 0  ? ( */}

          {totalPages > 1 && (
            <ReactPaginate
            previousLabel={<span className="paginate-label">{"< Previous"}</span>}
            nextLabel={<span className="paginate-label">{"Next >"}</span>}
              breakLabel={"..."}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              forcePage={pageOffset}
            />
          )}
        </div>
        <FooterContentSection />
      </div>
      {/* filter modal */}

      <Modal
        show={showFilterModel}
        onHide={() => setShowFilterModel(false)}
        backdrop={true}
        // backdrop={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <div className="mt-sm-2 mt-3 border mb-sm-2">
            <div className="sidebar-accordian p-3">
              <div>
                <span>
                  <b>Condition</b>
                </span>
                {FilterList?.condition
                  ?.filter((item) => item != 1)
                  ?.map((val, i) => {
                    return (
                      <Form.Group className="mb-2" controlId={val} key={i}>
                        <Form.Check
                          type="checkbox"
                          checked={
                            localStorage.getItem("condition")
                              ? JSON.parse(localStorage.getItem("condition"))[
                                  i
                                ][val == 2 ? "New" : "Used"]
                              : conditionKey[i][val == 2 ? "New" : "Used"]
                          }
                          onChange={(e) => conditionKeyFilter(e, i)}
                          name={val == 2 ? "New" : "Used"}
                          min={val}
                          label={val == 2 ? "New" : "Used"}
                        />
                      </Form.Group>
                    );
                  })}
                {conditionKey?.length > 5 ? (
                  <Button className="bg-none mb-3 border-0 p-0 text-dark">
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>
                    Show More
                  </Button>
                ) : null}
              </div>

              {/* Chipset */}
              <div>
                <span>
                  <b>Chipset</b>
                </span>
                {chipsetShow
                  ? FilterList?.chipset?.map((val, i) => {
                      return (
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={
                              localStorage.getItem("chipset")
                                ? JSON.parse(localStorage.getItem("chipset"))[
                                    i
                                  ][val]
                                : chipsetKey[i][val]
                            }
                            onChange={(e) => ChipsetFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      );
                    })
                  : FilterList?.chipset?.map((val, i) => {
                      return (
                        <>
                          {i < 3 ? (
                            <Form.Group
                              className="mb-2"
                              controlId={val}
                              key={i}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={
                                  localStorage.getItem("chipset")
                                    ? JSON.parse(
                                        localStorage.getItem("chipset")
                                      )[i][val]
                                    : chipsetKey[i][val]
                                }
                                onChange={(e) => ChipsetFilter(e, i)}
                                name={val}
                                label={val}
                              />
                            </Form.Group>
                          ) : null}
                        </>
                      );
                    })}
                {chipsetShow ? (
                  FilterList?.chipset?.length > 3 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlechipsetshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.chipset?.length > 3 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlechipsetshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              {/* Brand */}
              <div>
                <span>
                  <b>Brand</b>
                </span>
                {brandShow
                  ? FilterList?.brands?.map((val, i) => {
                      return (
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={
                              localStorage.getItem("brand")
                                ? JSON.parse(localStorage.getItem("brand"))[i][
                                    val
                                  ]
                                : brandKey[i][val]
                            }
                            onChange={(e) => BrandtFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      );
                    })
                  : FilterList?.brands?.map((val, i) => {
                      return (
                        <>
                          {i < 3 ? (
                            <Form.Group
                              className="mb-2"
                              controlId={val}
                              key={i}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={
                                  localStorage.getItem("brand")
                                    ? JSON.parse(localStorage.getItem("brand"))[
                                        i
                                      ][val]
                                    : brandKey[i][val]
                                }
                                onChange={(e) => BrandtFilter(e, i)}
                                name={val}
                                label={val}
                              />
                            </Form.Group>
                          ) : null}
                        </>
                      );
                    })}
                {brandShow ? (
                  FilterList?.brands?.length > 3 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlebrandshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.brands?.length > 3 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlebrandshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              {/* Series */}
              <div>
                <span>
                  <b>Series</b>
                </span>
                {seriesShow ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {FilterList?.series?.map((val, i) => {
                      return (
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={
                              localStorage.getItem("series")
                                ? JSON.parse(localStorage.getItem("series"))[i][
                                    val
                                  ]
                                : seriesKey[i][val]
                            }
                            onChange={(e) => seriesFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {FilterList?.series?.map((val, i) => {
                      return i < 6 ? (
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={
                              localStorage.getItem("series")
                                ? JSON.parse(localStorage.getItem("series"))[i][
                                    val
                                  ]
                                : seriesKey[i][val]
                            }
                            onChange={(e) => seriesFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      ) : null;
                    })}
                  </div>
                )}
                {seriesShow ? (
                  FilterList?.series?.length > 10 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handleSeriesshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-dash-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.series?.length > 3 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handleSeriesshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              {/* Model */}
              <div>
                <span>
                  <b>Model</b>
                </span>
                {modelShow ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {FilterList?.model?.map((val, i) => {
                      return (
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={modalKey[i][val]}
                            onChange={(e) => modalFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {FilterList?.model?.map((val, i) => {
                      return i < 6 ? (
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={modalKey[i][val]}
                            onChange={(e) => modalFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      ) : null;
                    })}
                  </div>
                )}
                {FilterList?.model?.length > 10 && (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => setModelShow(!modelShow)}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className={` ${
                          modelShow
                            ? "bi bi-dash-square-fill"
                            : "bi bi-plus-square-fill"
                        }`}
                        viewBox="0 0 16 16"
                      >
                        {modelShow ? (
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        ) : (
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                        )}
                      </svg>
                    </span>
                    Show {modelShow ? "Less" : "More"}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>

      <Login
        setSignup={setSignup}
        setForgot={setForgot}
        signup={signup}
        forgot={forgot}
        modal={() => setShowModal(false)}
        show={showModal}
        setShow={setShowModal} />
      <Footer />
    </div>
  );
};

export default UserBuySell;
